import { BinotelService } from "@/services/api/binotel.api.service"
import { CRMService } from "@/services/api/crm.api.service"
import { formatPhone } from "@/extensions/filters/filters"
import store from "@/store"

export const makeCall = async (clinic, phone) => {
    phone = formatPhone(phone)
    let outgoingCallThrough = clinic?.clinic_additional?.outgoing_calls || 'standard'
    const binotelConnected = store.getters.dynamicConfigValue('binotel_key') && store.getters.dynamicConfigValue('binotel_secret') && store.getters.dynamicConfigValue('binotel_internal')
    const sipuniConnected = store.getters.dynamicConfigValue('sipuni_key') && store.getters.dynamicConfigValue('sipuni_secret')
    const uisConnected = !!store.getters.dynamicConfigValue('uis_secret')
    const pbxConnected = store.getters.dynamicConfigValue('pbxSecret') && store.getters.dynamicConfigValue('pbxDomain')
    let res = null

    if(outgoingCallThrough === 'binotel') {
        if(binotelConnected) {
            res = await BinotelService.initiateCall(phone)
        } else {
            outgoingCallThrough = 'standard'
        }
    }

    if(!res && outgoingCallThrough === 'sipuni') {
        if(sipuniConnected) {
            res = await CRMService.initiateSipuniCall(phone)
        } else {
            outgoingCallThrough = 'standard'
        }
    }

    if(!res && outgoingCallThrough === 'uis') {
        if(uisConnected) {
            res = await CRMService.initiateUISCall(phone)
        } else {
            outgoingCallThrough = 'standard'
        }
    }

    if(!res && outgoingCallThrough === 'pbx') {
        if(pbxConnected) {
            res = await CRMService.initiatePBXCall(phone)
        } else {
            outgoingCallThrough = 'standard'
        }
    }

    if(!res && outgoingCallThrough === 'standard') {
        window.location = `tel:${phone}`
        res = true
    }
    return res
}
